var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"show":_vm.payLoading,"text":"支付中..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }